import { useEffect, useRef } from 'react';
import { isProduction } from 'src/utils/environment';

import {
  TEMP_STORED_PRODUCT_DATA,
  TEMP_STORED_PRODUCT_FILE,
} from '../../editProductPage/hooks/EditProductPage.helper';

export const useUnloadTempData = (productCode?: string) => {
  const shouldRemoveItemRef = useRef(true);
  const isFirstRender = useRef(true);

  // Remove temp stored data from sessionStorage
  useEffect(() => {
    const handleUnload = () => {
      if (shouldRemoveItemRef.current) {
        sessionStorage.removeItem(TEMP_STORED_PRODUCT_DATA(productCode));
        sessionStorage.removeItem(TEMP_STORED_PRODUCT_FILE(productCode));
      }
    };

    return () => {
      if (isProduction() || !isFirstRender.current) {
        handleUnload();
      } else {
        // handle react strict mode
        isFirstRender.current = false;
      }
    };
  }, [productCode]);

  return {
    shouldRemoveItemRef,
  };
};
